import {
  ButtonKind,
  ExtThemes,
  Size,
  WidthState,
} from '@usitsdasdesign/dds-ng/shared';
import { RoleEnum } from '../../../constants/Role.enum';

import { IntakeDocumentSubmissionTypeCode } from '../../../constants/intake-submission-type.enum';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import {
  DocumentStatus,
  IntakeDocumentStatusIdMapper,
} from '../../../constants/document-status.enum';
import {
  IntakeDocumentType,
  IntakeDocumentTypeToIdMapper,
} from '../../../constants/intake-document-type.enum';
import { IntakeOppertunitySubmissionStatus } from '../../../constants/intake-submission-status.enum';

export const ButtonOptions = {
  theme: ExtThemes.green,
  kind: ButtonKind.primary,
  size: Size.md,
  width: WidthState.fixed,
};

export const UploaderOptions = {
  heading: '',
  dragAndDropText: 'Drag and drop file(s)',
  description:
    'All common file types are supported including: docx, pptx, pdf, .zip, etc. Max size of 50MB per file',
  isDragAndDrop: true,
  isMultiple: true,
  acceptFormats: '',
  acceptExtensions: '',
  restrictedFormats: '',
  restrictedExtensions: '',
  exceptSymbols: '',
  btnLabel: 'Select file(s)',
  chooseFileBtnKind: 'primary',
  isDownloadable: false,
  allowFilesWithoutType: false,
  disabled: false,
  isInverse: false,
};

export const INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES: string[] = [
  RoleEnum.RISK_MANAGER,
  RoleEnum.SUPPORTING_RISK_MANAGER,
  RoleEnum.SPECIALIZED_RISK_MANAGER,
  RoleEnum.SYSTEM_ADMINISTRATOR,
  RoleEnum.REVIEWER,
  RoleEnum.TECHNICAL_INDEPENDENT_RISK_MANAGER,
  RoleEnum.RM_SUPPORT_GLOBAL,
];

export const DRAFT_FOR_REVIEW_DOC_STATUS_NOT_ALLOWED_ROLES: string[] = [
  RoleEnum.RISK_MANAGER,
  RoleEnum.SUPPORTING_RISK_MANAGER,
  RoleEnum.SPECIALIZED_RISK_MANAGER,
  RoleEnum.REVIEWER,
  RoleEnum.TECHNICAL_INDEPENDENT_RISK_MANAGER,
];

export const ADDITIONAL_RM_REVIEW_REVIEW_STATUS_ALLOWED_ROLES: string[] = [
  RoleEnum.RISK_MANAGER,
  RoleEnum.SUPPORTING_RISK_MANAGER,
  RoleEnum.SPECIALIZED_RISK_MANAGER,
  RoleEnum.REVIEWER,
  RoleEnum.TECHNICAL_INDEPENDENT_RISK_MANAGER,
];

export const updateDocStatusDropdown = (
  originalDocumentStatusArr: SelectItemOptions[],
  submissionTypeCode: string,
  submissionStatus: string,
  selectedDocTypeId: number,
  selectedDocStatusId: number,
): any => {
  let documentStatusOptions = [...originalDocumentStatusArr];
  let docStatusId: number | null = null;

  const isSubmissionPRO =
    submissionTypeCode === IntakeDocumentSubmissionTypeCode.PRO;
  const isSubmissionCO =
    submissionTypeCode === IntakeDocumentSubmissionTypeCode.CO;
  const isPendingCloseout = [
    IntakeOppertunitySubmissionStatus.RM_REVIEWED_PENDING_CLOSEOUT,
    IntakeOppertunitySubmissionStatus.SELF_REVIEWED_PENDING_CLOSEOUT,
  ].includes(submissionStatus as IntakeOppertunitySubmissionStatus);

  const isDocTypeCO =
    selectedDocTypeId ===
    IntakeDocumentTypeToIdMapper[IntakeDocumentType.ChangeOrder];
  const isDocTypeRFP =
    selectedDocTypeId ===
    IntakeDocumentTypeToIdMapper[IntakeDocumentType.RequestForProposal];
  const isExecutedDocument = [
    IntakeDocumentTypeToIdMapper[IntakeDocumentType.EngagementLetter],
    IntakeDocumentTypeToIdMapper[
      IntakeDocumentType.ExecutedEngagementLetterOrSOWOrCOOrContract
    ],
    IntakeDocumentTypeToIdMapper[
      IntakeDocumentType.OriginalExecutedInterimEngagementLetter
    ],
  ].includes(selectedDocTypeId);

  if (isSubmissionPRO && isDocTypeRFP) {
    documentStatusOptions = originalDocumentStatusArr.filter(
      (status) =>
        status.value ===
        IntakeDocumentStatusIdMapper.get(DocumentStatus.SupportingDocument)
    );
  } else if (isSubmissionCO) {
    if ((isPendingCloseout && isDocTypeCO) || isExecutedDocument) {
      documentStatusOptions = originalDocumentStatusArr;
    } else if (
      selectedDocTypeId ===
      IntakeDocumentTypeToIdMapper[
        IntakeDocumentType.ExecutedEngagementLetterOrSOWOrCOOrContract
      ]
    ) {
      documentStatusOptions = documentStatusOptions.filter(
        (status) =>
          status.value ===
          IntakeDocumentStatusIdMapper.get(DocumentStatus.SupportingDocument)
      );
    } else {
      documentStatusOptions = documentStatusOptions.filter(
        (status) =>
          status.value !==
          IntakeDocumentStatusIdMapper.get(
            DocumentStatus.FinalArchiveReadyVersion
          )
      );

      if (
        selectedDocStatusId ===
        IntakeDocumentStatusIdMapper.get(
          DocumentStatus.FinalArchiveReadyVersion
        )
      ) {
        docStatusId = 0;
      }
    }
  }

  return {
    statusOptions: documentStatusOptions,
    selectedDocStatus: docStatusId,
  };
};
